import { useState } from 'react'
import { omit } from 'lodash'
import { SubmitHandler } from 'react-hook-form';
import MenuItemForm from "./MenuItemForm";
import useUpdateMenuItem from '../../hooks/MenuItem/useUpdateMenuItem'
import useMenu from '../../hooks/Menu/useMenu'
import { useToast } from "../../context/ToastContext";
import Spinner from '../../components/ui/spinner';

import type { MenuItemLang } from "../../types/menuItemTypes";

import type { 
  MenuItem,
  MenuItemVariables
} from '../../types/menuItemTypes';

type MenuItemEditProps = {
  menuItem: MenuItem;
  closeModal?: () => void | undefined;
}

const MenuItemEdit: React.FC<MenuItemEditProps> = ({
  menuItem: mi,
  closeModal
}) => {
  const toast = useToast();
  const [menuItem, setMenuItem] = useState<MenuItem>(mi);
  const { updateMenuItem } = useUpdateMenuItem({
    onCompleted: (menuItemUpdated) => {
      if (menuItemUpdated) {
        toast.success(`Menu item updated successfully`);
        setMenuItem(menuItemUpdated)
        closeModal?.()
      };
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });
  const { menu, loading } = useMenu(mi.menuId, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });

  if (loading || !menu) return <Spinner />;

  const onSubmit: SubmitHandler<MenuItemVariables>  = async formValues => {
    try {
      await updateMenuItem({
        id: menuItem.id,
        sugarFree: formValues.sugarFree,
        glutenFree: formValues.glutenFree,
        cornFree: formValues.cornFree,
        dairyFree: formValues.dairyFree,
        eggsFree: formValues.eggsFree,
        fishFree: formValues.fishFree,
        legumesFree: formValues.legumesFree,
        peanutFree: formValues.peanutFree,
        seedsFree: formValues.seedsFree,
        shellfishFree: formValues.shellfishFree,
        treeNutsFree: formValues.treeNutsFree,
        vegan: formValues.vegan,
        chili: formValues.chili,
        hot: formValues.hot,
        amount: formValues.amount,
        unit: formValues.unit,
        amountInBase: formValues.amountInBase,
        mass: formValues.mass,
        price: formValues.price,
        proteins: formValues.proteins,
        fats: formValues.fats,
        carbohydrates: formValues.carbohydrates,
        calories: formValues.calories,
        image: formValues.image instanceof FileList ? formValues.image[0] : formValues.image,
        menuItemLangs: formValues.menuItemLangs.map(lang => omit(lang, ['__typename'])) as MenuItemLang[],
        menuSectionIds: formValues.menuSectionIds
      });
    } catch (err) {
      console.error("menu create error (component):", err);
      // toast
    }
  }

  return (
    <MenuItemForm onSubmit={onSubmit} menuItem={menuItem} menu={menu} />
  );
}

export default MenuItemEdit;
